import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  mutations: {},
  actions: {
    getLogsInRange(_, { start, end }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/logs/range",
            method: "POST",
            data: { start, end }
          })
          .then(resolve)
          .catch(reject);
      });
    },
    getDailyLogs() {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/logs/today",
            method: "GET"
          })
          .then(resolve)
          .catch(reject);
      });
    },
    getAllLogs() {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/logs/all",
            method: "GET"
          })
          .then(resolve)
          .catch(reject);
      });
    },
    insertNewEvent(_, payload) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/logs/insertEvent",
            method: "POST",
            data: payload
          })
          .then(resolve)
          .catch(reject);
      });
    }
  },
  getters: {}
};
